let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lPbRe")).then(() => parcelRequire('iNLnG'));